import React, {
    useContext
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Button } from '@jutro/components';
import CommonConstants from 'sg-common-constants';
import messages from './SgOtherProducts.messages';

function SgOtherProducts(props) {
    const {
        hideProducts
    } = props;

    const translator = useContext(TranslatorContext);

    return (
        <>
            <div>
                <div className="sgCrossSellBannerContainer">
                    <h3>{translator(messages.DoYouKnow)}</h3>
                    {!hideProducts.hideMotor && (
                        <div id="carInsurancePod" className="sgPod">
                            <div id="carInsuranceImageTextBox" className="sgCrossSellPodImageTextBox">
                                <div className="sgCrossSellPodImage car-img" />
                                <h4 className="sgCrossSellPodHeader">{translator(messages.CarInsuranceHeader)}</h4>
                            </div>
                            <div id="carInsuranceTextButtonBox" className="sgCrossSellPodTextButton">
                                <h3 className="sgCrossSellPodHeader">{translator(messages.CarInsuranceHeader)}</h3>
                                <Button
                                    id="carInsuranceButton"
                                    className="sgPrimaryWhiteButton sgPodButton"
                                    onClick={() => window.open(CommonConstants.SAGA_PRODUCTS_LINKS.CAR, '_blank')}
                                >
                                    {translator(messages.FindOutMore)}
                                </Button>
                            </div>
                        </div>
                    )}
                    {!hideProducts.hideHome && (
                        <div id="homeInsurancePod" className="sgPod">
                            <div id="homeInsuranceImageTextBox" className="sgCrossSellPodImageTextBox">
                                <div className="sgCrossSellPodImage home-img" />
                                <h4 className="sgCrossSellPodHeader">{translator(messages.HomeInsuranceHeader)}</h4>
                            </div>
                            <div id="homeInsuranceTextButtonBox" className="sgCrossSellPodTextButton">
                                <h3 className="sgCrossSellPodHeader">{translator(messages.HomeInsuranceHeader)}</h3>
                                <Button
                                    id="homeInsuranceButton"
                                    className="sgPrimaryWhiteButton sgPodButton"
                                    onClick={() => window.open(CommonConstants.SAGA_PRODUCTS_LINKS.HOME, '_blank')}
                                >
                                    {translator(messages.FindOutMore)}
                                </Button>
                            </div>
                        </div>
                    )}
                    {!hideProducts.hideSmi && (
                        <div id="healthInsurancePod" className="sgPod">
                            <div id="healthInsuranceImageTextBox" className="sgCrossSellPodImageTextBox">
                                <div className="sgCrossSellPodImage health-img" />
                                <h4 className="sgCrossSellPodHeader">{translator(messages.HealthInsuranceHeader)}</h4>
                            </div>
                            <div id="healthInsuranceTextButtonBox" className="sgCrossSellPodTextButton">
                                <h3 className="sgCrossSellPodHeader">{translator(messages.HealthInsuranceHeader)}</h3>
                                <Button
                                    id="healthInsuranceButton"
                                    className="sgPrimaryWhiteButton sgPodButton"
                                    onClick={() => window.open(CommonConstants.SAGA_PRODUCTS_LINKS.HEALTH, '_blank')}
                                >
                                    {translator(messages.FindOutMore)}
                                </Button>
                            </div>
                        </div>
                    )}
                    {!hideProducts.hideTravel && (
                        <div id="travelInsurancePod" className="sgPod">
                            <div id="travelInsuranceImageTextBox" className="sgCrossSellPodImageTextBox">
                                <div className="sgCrossSellPodImage travel-img" />
                                <h4 className="sgCrossSellPodHeader">{translator(messages.TravelInsuranceHeader)}</h4>
                            </div>
                            <div id="travelInsuranceTextButtonBox" className="sgCrossSellPodTextButton">
                                <h3 className="sgCrossSellPodHeader">{translator(messages.TravelInsuranceHeader)}</h3>
                                <Button
                                    id="travelInsuranceButton"
                                    className="sgPrimaryWhiteButton sgPodButton"
                                    onClick={() => window.open(CommonConstants.SAGA_PRODUCTS_LINKS.TRAVEL, '_blank')}
                                >
                                    {translator(messages.FindOutMore)}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default SgOtherProducts;
